import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Escritório', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Equipe', href: '#equipe' },
  { label: 'Como Atuamos', href: '#como-atuamos' },
  { label: 'Contato', href: '#contato' },
];

const WA_LINK = 'https://wa.me/5541992570505?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20especialista%20da%20KPR%20Advogados.';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 bg-kpr-cream ${
        scrolled
          ? 'border-b border-kpr-gold/25 py-3 shadow-sm'
          : 'py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 shrink-0">
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/5b523bf4e9f873538aefa42204d27026.png"
            alt="KPR Advogados Associados"
            className="w-auto object-contain"
            style={{ height: '92px' }}
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-kpr-dark/70 hover:text-kpr-dark text-xs font-medium tracking-[0.12em] uppercase transition-colors duration-300 whitespace-nowrap cursor-pointer relative group"
            >
              {link.label}
              <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-kpr-dark group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        {/* CTA Button – green */}
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="hidden lg:flex items-center gap-2 bg-kpr-dark hover:bg-kpr-medium text-white font-medium text-xs tracking-wider uppercase px-6 py-2.5 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-base w-4 h-4 flex items-center justify-center" />
          Falar no WhatsApp
        </a>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center text-kpr-dark cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menu"
        >
          <i className={`text-xl w-6 h-6 flex items-center justify-center ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-kpr-cream border-t border-kpr-gold/20 px-8 py-6">
          <nav className="flex flex-col gap-5 mb-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-kpr-dark/70 hover:text-kpr-dark text-xs font-medium tracking-[0.15em] uppercase py-1 cursor-pointer transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-2 bg-kpr-dark hover:bg-kpr-medium text-white font-medium text-xs tracking-wider uppercase px-6 py-3 whitespace-nowrap cursor-pointer transition-all duration-300"
          >
            <i className="ri-whatsapp-line text-base w-4 h-4 flex items-center justify-center" />
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
